<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {}
  },
  beforeMount () {
    // alert(document.body.clientWidth + '-' + document.body.clientHeight)
    // if (document.body.clientWidth < 500) {
    //   this.$router.push('/about')
    // }
  },
  mounted () {
    console.log(this.$route, 'this.touteetas')
    if (this.$route.path && this.$route.path.length > 2) {
      this.$router.push('/404')
    }
  }
}

</script>

<style lang="scss">
  html, body {
    margin: 0;
    padding: 0;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
    width: 100%;
  }
::-webkit-scrollbar{
  width:6px;
  height:100%;
}
::-webkit-scrollbar-thumb{
width:4px;
height:60px;
background-color:#ccc;
border-radius:3px;
}
::-webkit-scrollbar-track
{
  border-radius: 10px;
  background-color: rgba(255,255,255,.5);
}
</style>
